import { computed, ComputedRef, readonly, Ref, ref } from 'vue';
import { IApiResponse, Nullable } from '@/types';

export abstract class AsyncRefWrapper<T> {
  private readonly _isLoading = ref<boolean>(false);
  private readonly _error = ref<Nullable<Error>>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly _headers = ref<Nullable<any>>(null);
  private readonly _success = ref<boolean>(false);
  protected readonly _data: Ref<T>;

  constructor(initialValue: T) {
    this._data = ref<T>(initialValue) as Ref<T>;
  }

  public get isLoading(): Readonly<Ref<boolean>> {
    return readonly(this._isLoading);
  }

  public get error(): Readonly<Ref<Nullable<Error>>> {
    return readonly(this._error);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public get headers(): Readonly<Ref<Nullable<any>>> {
    return readonly(this._headers);
  }

  public get success(): Readonly<Ref<boolean>> {
    return readonly(this._success);
  }

  public get data(): ComputedRef<T> {
    return computed(() => {
      return this._data.value;
    });
  }

  protected loadFrom(source: Promise<IApiResponse<T>>): Promise<void> {
    if (this._isLoading.value) {
      return Promise.reject('Already loading (Race Condition)');
    } else {
      this._isLoading.value = true;
      return source
        .then((response: IApiResponse<T>) => {
          this._data.value = response.data;
          this._headers.value = response.headers;
          this._success.value = true;
          this._isLoading.value = false;
        })
        .catch((e: Error) => {
          this._error.value = e;
          this._success.value = false;
          this._isLoading.value = false;
        });
    }
  }
}
